import React, { useState, createContext, useEffect } from "react"

const defaultState = {
  theme: "light",
  changeTheme: () => { },
}

const ThemeContext = createContext(defaultState)

function ThemeProvider({ children }) {
  const [supportsDarkMode, setSupportsDarkMode] = useState(false)
  const [theme, setTheme] = useState("light")

  const changeTheme = theme => {
    if (supportsDarkMode && theme === "dark") {
      localStorage.setItem("supportsDarkModeReplaced", true)
    }
    if (supportsDarkMode && theme === "light") {
      localStorage.setItem("supportsDarkModeReplaced", false)
    }
    localStorage.setItem("theme", theme)
    setTheme(theme)
  }
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const lsDark = localStorage.getItem("theme")
      const darkModeReplaced = localStorage.getItem("supportsDarkModeReplaced")
      const systemPrefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches

      setSupportsDarkMode(systemPrefersDark)

      // Theme setzen
      let initialTheme = "light"
      if (lsDark === "dark") {
        initialTheme = "dark"
      } else if (systemPrefersDark && !darkModeReplaced) {
        initialTheme = "dark"
      }
      
      setTheme(initialTheme)

      // Bootstrap 5.3 Theme beim Mount setzen
      document.documentElement.setAttribute('data-bs-theme', initialTheme);
      document.documentElement.setAttribute('data-theme', initialTheme);
      document.body.setAttribute('data-theme', initialTheme);
    }
  }, [theme])

  return (
    <ThemeContext.Provider
      value={{
        theme,
        changeTheme,
      }}
    >
      {children}
    </ThemeContext.Provider>
  )
}

export default ThemeContext
export { ThemeProvider }
